import { FormattedMessage } from 'react-intl';

import ExclamationCircleIcon from '@/assets/icons/exclamation-circle.svg';
import { Typography } from '@/components/ui/typography';

export function EditWarningBanner() {
  return (
    <div className="bg-fx-amber-50 flex items-center gap-2 rounded p-2">
      <img src={ExclamationCircleIcon} alt="" />
      <Typography variant="body1">
        <FormattedMessage
          defaultMessage="Editing campaign parameters is not available yet for this channel."
          description="Warning banner shown when users try to edit campaign parameters for channels where editing is not currently supported but will be available in the future. Indicates a temporary limitation."
        />
      </Typography>
    </div>
  );
}
